// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__1698t","content":"Slider_content__3leIL","startText":"Slider_startText__3g4bj","endText":"Slider_endText__2k0q8"};